import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const Insight: React.FC = () => {
  // Metallic Frosted Glass Style (reused for consistency)
  const metallicGlassStyle = "bg-gradient-to-br from-white/90 via-gray-50/80 to-gray-100/90 backdrop-blur-xl border border-white/60 shadow-[0_8px_30px_rgba(0,0,0,0.04)] ring-1 ring-white/80 hover:shadow-[0_20px_40px_rgba(0,0,0,0.08)] hover:bg-white transition-all duration-500";

  return (
    <section className="min-h-screen flex items-center justify-center py-24 bg-gray-50 relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-gray-50 to-gray-100 -z-10"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          {/* 3 Bullet Points */}
          <div className="flex flex-col md:flex-row justify-center gap-6 md:gap-8 mb-16 animate-fade-in-up">
            {[
              "你要的不是更多人，而是更少的不确定性",
              "你要的不是爆一次，而是每周都能稳定发表",
              "让内容不再依赖某个人的状态，而依赖系统"
            ].map((text, i) => (
              <div key={i} className={`${metallicGlassStyle} flex items-center gap-3 text-left md:text-center px-6 py-5 rounded-xl`}>
                <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 shadow-sm">
                  <CheckCircle2 className="w-4 h-4 text-green-600" />
                </div>
                <span className="text-sm font-bold text-gray-700">{text}</span>
              </div>
            ))}
          </div>

          {/* Large Headline */}
          <h3 className="text-3xl md:text-5xl font-bold text-gray-900 leading-tight mb-8 animate-fade-in-up delay-200">
            「你缺的不是热情，缺的是一套让团队<br className="hidden md:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-accent-600">持续稳定输出</span>的内容生产体系。」
          </h3>

          {/* Small Text */}
          <p className="text-gray-500 text-xl animate-fade-in-up delay-300">
            把内容从“<span className="text-primary-600 font-bold">个人努力</span>”升级为“<span className="text-primary-600 font-bold">组织能力</span>”，让团队更稳定、更可控。
          </p>
        </div>
      </div>
    </section>
  );
};

export default Insight;